import {Stack} from "@mui/material";
import ContentBox from "./ContentBox";
import React from "react";
import {useTranslation} from "react-i18next";

export interface RdlAuthenticationProps {
    message: string;
    err?: string;
    job?: RdlJob;
}

export interface RdlJob {
    retries: number;
    ID: number;
}

export default function RdlAuthentication(props: Readonly<RdlAuthenticationProps>) {
    const {message, err, job} = props;
    const {t} = useTranslation();
    return (
        <Stack direction="column">
            <ContentBox>{message}</ContentBox>
            {err && err?.length > 0 && (
                <ContentBox>
                    {t("generic_errorResponseTitle")} : {err}
                </ContentBox>
            )}

            {job && (
                <>
                    <ContentBox>
                        {t("deviceHistoryjobID")} : {job?.ID}
                    </ContentBox>
                    <ContentBox>
                        {t("deviceJob_retries")} : {job?.retries || 0}
                    </ContentBox>
                </>
            )}
        </Stack>
    );
}
